<template>
    <div id="FAQ" class="FAQ-container">
        <img
            class="base-banner"
            v-src="'https://oss.cloud.custouch.com/res/11271/有问必答@3x.png'"
        />
        <div class="header">
            <h4>
                {{ title }}
                <div class="icon-right">
                    <a
                        class="icon-wrapper"
                        href="https://byk.cloud.pageseagle.com/1085084080065740800/1130393315728949248/default"
                        v-if="!isAStaff"
                    >
                        <van-icon name="question-o" />帮助中心
                    </a>
                    <a class="icon-wrapper" :href="newFormUrl">
                        <img src="https://oss.cloud.custouch.com/res/178863/icon-seek@3x.png" alt="">咨询新问题
                    </a>
                </div>
            </h4>
        </div>
        <div class="content">
            <van-popover
                v-model="showList"
                trigger="click"
                get-container="#FAQ"
            >
                <template #reference>
                    <div :class="['popover-active', !activeId? 'popover-default' : '']">
                        <div>{{ activeId ? showName() : '请选择应用领域' }}</div>
                        <van-icon name="arrow-down" color="#022364" />
                    </div>
                </template>
                <div class="content-list">
                    <div v-for="item in hierarchies" :key="item.id" @click="select(item.id)" :class="['item', activeId === item.id ? 'item-active' : '']">{{ item.name }}</div>
                </div>
            </van-popover>
            <div v-if="list.loading" class="loading-wrapper">
                <van-loading></van-loading>
            </div>
            <van-collapse v-model="collapseId" accordion :border="false">
                <van-collapse-item v-for="item in list.data" :key="item.id" :name="item.id" :border="false">
                    <template #title>
                        <div class="collapse-title">{{ item.detail.question }}</div>
                    </template>
                    <RichText v-if="item.detail.answer" :data="item.detail.answer" class="collapse-answer"></RichText>
                </van-collapse-item>
            </van-collapse>
            <van-pagination v-if="showPage" v-model="list.paganation.index" :total-items="list.paganation.total" :items-per-page="list.paganation.size" @change="changePage">
                <template #prev-text>
                    <img class="page-btn" src="https://oss.cloud.custouch.com/res/178990/Item备份_6.png" alt="">
                </template>
                <template #next-text>
                    <img class="page-btn" src="https://oss.cloud.custouch.com/res/178989/Item.png" alt="">
                </template>
                <template #page="{ text }">
                    <div class="page-text">{{ text }}</div>
                </template>
            </van-pagination>
        </div>
    </div>
</template>
<script>
const {
    VUE_APP_NEW_QUESTION,
    VUE_APP_FORM,
    CMS
} = window.env
import { getSource } from './source'
import { concatURI } from '@/utils/common'
import { getDataHierarchies, getDataRows, getPathNames } from '@custouch/proxy-use'
import RichText from '@/views/components/RichText.vue'
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        lpName: {
            type: String,
            default: ''
        },
        lpType: {
            type: String,
            default: ''
        }
    },
    components: {
        RichText
    },
    data() {
        return {
            newFormUrl: VUE_APP_FORM + VUE_APP_NEW_QUESTION,
            showList: false,
            activeId: '',
            hierarchies: [],
            list: {
                data: [],
                loading: false,
                paganation: {
                    index: 1,
                    size: 5,
                    total: 0
                }
            },
            collapseId: '',
            showPage: false
        }
    },
    methods: {
        setFormUrl() {
            this.newFormUrl = VUE_APP_FORM + VUE_APP_NEW_QUESTION
            const { query } = this.$route
            const queryEntries = Object.entries(query)
            const filterKeys = queryEntries.filter(([key]) => /^c_/.test(key))
            const t = [{ key: 'c_m_source', val: getSource() }]
            if (this.lpType && this.lpName) {
                t[0].val = this.lpType + '-' + this.lpName
            }
            if (filterKeys.length) {
                // 预填充一些行业信息
                t.push(...filterKeys.map(([key, val]) => ({ key, val })))
            }
            this.newFormUrl = concatURI(this.newFormUrl, t)
        },
        async initData(){
            const ret = await getDataHierarchies(CMS.module.question)
            this.hierarchies = ret
            if(this.$route.query.hId){
                this.select(this.$route.query.hId)
            }else{
                this.$root.$emit('actionview', {
                    info: {
                        title: this.$route.meta.title
                    },
                    actionType: 'pageview'
                })
            }
        },
        showName(){
            let info = this.hierarchies.find(item=>item.id === this.activeId)
            return info?.name
        },
        async select(hId){
            this.showList = false
            if(this.activeId === hId) return
            this.$router.replace({query: {hId}})
            this.activeId = hId
            this.collapseId = ''
            this.list.paganation.index = 1
            const path = await getPathNames(this.activeId)
            const { index, size } = this.list.paganation
            this.getList({index, size})
            this.$root.$emit('actionview', {
                info: {
                    title: path
                },
                actionType: 'pageview'
            })
            this.setFormUrl()
        },
        async getList({ index, size }){
            this.list.data = []
            this.list.loading = true
            const ret = await getDataRows({
                dataHierarchyId: this.activeId,
                dataTemplateId: CMS.template.question,
                index,
                size,
                orderBy: 'index',
                desc: false
            })
            this.list.paganation.total = ret.total
            this.list.data = ret.data
            this.showPage = ret.total > this.list.paganation.size
            this.list.loading = false
        },
        async changePage(){
            const { index, size } = this.list.paganation
            this.getList({ index,size })
        }
    },
    async mounted(){
        this.setFormUrl()
        this.initData()
    }
}
</script>
<style lang="less" scoped>
.FAQ-container{
    background: #F9F9F9;
    .base-banner{
        vertical-align: bottom;
    }
    .header{
        padding: @spacing 0.8rem;
        background: @white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h4 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
            .icon-right {
                display: flex;
                align-items: center;

                a:not(:last-child) {
                    margin-right: @padding-md;
                }
            }
            .icon-wrapper {
                font-size: 0.7rem;
                line-height: @spacing;
                letter-spacing: -0.05rem;
                font-weight: 400;
                color: #00A6EC;
                display: flex;
                align-items: center;
                white-space: nowrap;
                i {
                    margin-right: 0.2rem;
                }
                img{
                    height: 0.7rem;
                    object-fit: contain;
                    margin-right: 0.3rem;
                    vertical-align: middle;
                }
            }
        }
    }
    .content{
        padding: 0.8rem 0.8rem 1.75rem;
        .van-popover__wrapper{
            width: 100%;
            .popover-active{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.6rem 0.8rem;
                border: 1px solid @green;
                color: @black;
            }
            .popover-default{
                color: #646466;
            }
        }
        .van-collapse-item{
            margin-top: 0.9rem;
            .collapse-title{
                line-height: @spacing;
                font-weight: 500;
                color: #022364;
            }
            .collapse-answer{
                padding-top: 0.8rem;
                border-top: 1px solid #022364;
            }
        }
        .van-pagination{
            margin-top: 2rem;
            .page-btn{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .page-text{
                width: 2.3rem;
                height: 2.3rem;
                font-size: 0.9rem;
                line-height: 2.3rem;
                text-align: center;
                transform: scale(0.5);
            }
        }
        .loading-wrapper {
            display: flex;
            justify-content: center;
            padding: 1rem;
        }
    }
}
</style>
<style lang="less">
.FAQ-container{
    .van-popup{
        background: transparent;
    }
    .van-popover{
        width: 100%;
        padding: 0 0.8rem 0.8rem;
        .van-popover__arrow{
            display: none;
        }
        .van-popover__content{
            border-radius: 0;
            box-shadow: none;
            .content-list{
                padding: 0.41rem 0.38rem;
                .item{
                    padding: 0.2rem 0.43rem;
                    color: #646466;
                    margin-bottom: 0.3rem;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                .item-active{
                    background: rgba(153, 210, 254, 0.09);
                    color: @green;
                }
            }
        }
    }
    .van-collapse-item{
        .van-cell{
            padding: 0.8rem;
            &::before{
                content: '';
                display: block;
                width: 0.2rem;
                height: 0.73rem;
                background: #00A6EC;
                position: absolute;
                top: 0.85rem;
                left: 0;
            }
            .van-cell__right-icon{
                color: #636161;
                margin-left: 0.85rem;
                font-size: 0.53rem;
            }
        }
        .van-collapse-item__content{
            padding: 0 0.8rem 0.8rem;
            color: #646466;
        }
    }
    .van-pagination{
        justify-content: center;
        .van-pagination__page{
            color: #64626A;
            margin-right: 0.6rem;
        }
        .van-pagination__item--active{
            color: @white;
            background: @green;
        }
        .van-pagination__prev{
            margin-right: 0.6rem;
        }
        .van-pagination__item{
            width: 1.13rem;
            height: 1.13rem;
            flex: 0 0 1.13rem;
            padding: 0;
            min-width: 0;
        }
        [class*='van-hairline']::after{
            border: 1px solid #E8E7E8;
        }
    }
}
</style>